import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { BaasEdgePoolError } from '../../sections/types/BaasEdgePoolError';

export interface IDeleteSmbVolumeParams {
    poolId: string;
    path: string;
}

export interface IDeleteSmbVolumeResult extends IResult {
    success?: {
        poolId: string;
    };
    error?: BaasEdgePoolError;
}

export class DeleteSmbVolumeRequest extends Request<IDeleteSmbVolumeParams, IDeleteSmbVolumeResult> {
  constructor(params: IDeleteSmbVolumeParams) {
    super('deleteSmbVolumeForPool', params);
  }
}
